
function copyText() {
  const ele = document.getElementById("url-copy");
  ele.select();
  ele.setSelectionRange(0, 99999); // Hỗ trợ cho các trình duyệt di động
  document.execCommand("copy");
}

export function init() {
  const ele = $('.btn-copy-url')
  ele.click(function () {
    copyText();
    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": false,
      "progressBar": true,
      "positionClass": "toast-top-right",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "5000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }
    toastr["success"]("Sao chép thành công.")
  });
}

